import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ReactiveFormsModule } from '@angular/forms'

import { IonicModule } from '@ionic/angular'

import { CreateEditSubcollectionPageRoutingModule } from './create-edit-subcollection-routing.module'

import { CreateEditSubcollectionPage } from './create-edit-subcollection.page'
import { ButtonModule } from 'primeng/button'
import { InputTextModule } from 'primeng/inputtext'

@NgModule({
  imports: [CommonModule, InputTextModule, ReactiveFormsModule, IonicModule, ButtonModule, CreateEditSubcollectionPageRoutingModule],
  declarations: [CreateEditSubcollectionPage],
})
export class CreateEditSubcollectionPageModule {}
